module.exports = __webpack_public_path__ + "static/when-breath-becomes-air-0ded8f4483a15207fd06aa3a7ace94b7.jpg";